module.exports = __webpack_public_path__ + "img/banner-gleede-mobile.811a9cc8.svg";